export interface SeoMeta {
  title: string;
  description: string;
}

export const pageSeoConfig: Record<
  | "home"
  | "apparel"
  | "computers"
  | "gifts"
  | "others"
  | "dtc"
  | "walmart"
  | "amazon",
  SeoMeta
> = {
  home: {
    title:
      "Promo Codes and Coupons for Top Brands with Latest Deals and Discounts",
    description:
      "Find the best promo codes, coupons and deals for top brands. Save on electronics, fashion, beauty and more with verified offers, updated regularly.",
  },
  apparel: {
    title:
      "Apparel Promo Codes and Coupons with Fashion Deals and Discounts",
    description:
      "Find the latest apparel promo codes, coupons and deals. Save on clothing, shoes and fashion accessories with verified discounts and updated offers.",
  },
  computers: {
    title:
      "Computers Promo Codes and Coupons with Tech Deals and Discounts",
    description:
      "Discover computers promo codes, coupons and deals. Save on laptops, desktops, accessories and electronics with verified discounts and special offers.",
  },
  gifts: {
    title: "Gift Promo Codes and Coupons with Deals and Special Offers",
    description:
      "Browse gift promo codes, coupons and deals. Save on gift cards, personalized gifts and special items with verified discounts and updated offers.",
  },
  others: {
    title:
      "More Promo Codes and Coupons with Latest Deals and Discounts",
    description:
      "Explore more promo codes, coupons and deals across various categories. Find verified discounts and special offers updated regularly.",
  },
  dtc: {
    title: "DTC Brand Promo Codes and Coupons with Latest Deals and Discounts",
    description:
      "Browse DTC brand promo codes, coupons and deals. Compare direct-to-consumer offers and save with verified discounts updated regularly.",
  },
  walmart: {
    title:
      "Walmart Brand Promo Codes and Coupons with Latest Deals and Discounts",
    description:
      "Find Walmart brand promo codes, coupons and deals. Save on marketplace brands with verified discounts and updated offers.",
  },
  amazon: {
    title:
      "Amazon Brand Promo Codes and Coupons with Latest Deals and Discounts",
    description:
      "Discover Amazon brand promo codes, coupons and deals. Save on Amazon sellers and brands with verified discounts and updated offers.",
  },
};

export const defaultBrandSeoDescription =
  "Discover the latest coupons, promo codes, and deals from this brand. Save more with updated offers and trusted discounts.";

export const defaultBrandSeoTitle = "Brand Coupons | CodesSeek";
